import { Component, OnInit } from '@angular/core';
import { AppSingle } from '../../app-single';
import { DependentMeepServerModel } from '../../models/dependent.model';
import { ActivatedRoute } from '@angular/router';
import { DependentService } from '../../services/dependent.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';
import { CurrencyModel } from '../input/rules/implementations/currency.model';
import { MaskHelper } from '../../helpers/mask';

@Component({
  selector: 'app-daily-limit',
  templateUrl: './daily-limit.component.html',
  styleUrls: ['./daily-limit.component.less']
})
export class DailyLimitComponent extends AppSingle implements OnInit {

  dependent: DependentMeepServerModel = new DependentMeepServerModel();
  dailyLimit: number;
  hasDailyLimit: boolean;
  dailyLimitToShow;
  dailyLimitInputModel;

  constructor(route: ActivatedRoute, private dependentsService: DependentService, private notificationService: NotificationService) {
    super(route);
    this.dailyLimitInputModel = new InputModel(false, false, 'tel', 'R$ 0,00', [new RequiredModel()], new CurrencyModel());
  }

  private setDailyLimit(dailyLimit, msg: string) {
    this.dependentsService.updateDailyLimit(this.dependent.Tag, dailyLimit)
      .then(() => {
        this.notificationService.showSuccessNotification(msg);
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  ngOnInit() {
    this.dependentsService.getFromMeepServer(this.id)
      .then((_dependent: DependentMeepServerModel) => {
        this.dependent = _dependent;
        if (_dependent.LimiteDiario) {
          this.dailyLimitToShow = _dependent.LimiteDiario.toFixed(2);
          this.hasDailyLimit = true;
        } else {
          this.dependent.LimiteDiario = 0;
          this.dailyLimitToShow = 0;
          this.hasDailyLimit = false;
        }
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  disableDailyLimit(event) {
    if (!event.checked) {
      this.notificationService.showQuestionNotification('Você deseja remover o limite diário?')
        .then((result) => {
          if (result.value) {
            this.setDailyLimit(null, 'Limite removido com sucesso!');
          } else {
            this.hasDailyLimit = true;
          }
        });
    } else {
      this.hasDailyLimit = true;
    }
  }

  enableDailyLimit() {
    if (this.dailyLimitToShow && MaskHelper.moneyToFloat(this.dailyLimitToShow) > 0) {
      const formatedValue = MaskHelper.moneyToFloat(this.dailyLimitToShow);
      this.setDailyLimit(formatedValue, 'Limite adicionado com sucesso!');
    } else {
      this.notificationService.showErrorNotification('Preencha um valor para o limite diário!');
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/daily-limit/daily-limit.component.ts